import * as React from 'react';
import FlagIconFactory from 'react-flag-icon-css';

export default FlagIconFactory(React, { useCssModules: false });
